<template>
  <div class="flex flex-col gap-md">
    <info-table
      v-if="!isLoading"
      :queue-attributes="queueAttributes"
    />
    <div v-if="isLoading">
      <OrSkeletonTextV3
        :font-size="16"
        :line-height="40"
        :lines-count="5"
        animated
      />
    </div>
  </div>
</template>
<script lang="ts">

import { defineComponent, PropType } from 'vue';
import { OrSkeletonTextV3 } from '@onereach/ui-components';
import { QueueAttributes } from '../../types';
import InfoTable from './InfoTable.vue';

export default defineComponent({
  name: 'QueuesInfoForm',
  components: {
    OrSkeletonTextV3,
    InfoTable,
  },
  props: {
    queueAttributes: {
      type: Object as PropType<QueueAttributes>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
</script>
